// ─── SQUARE MEMBERSHIP LOOKUP ─────────────────────────────────────────────────
// Fetches customer membership custom attributes through the /api/square-attributes
// proxy, keyed by (lowercased) email. Results are cached for the session so the
// same customer isn't looked up twice.

const cache = new Map(); // emailLower -> [{ name, value }]

export async function fetchMembership(emails) {
  const norm = [...new Set((emails || []).map(e => (e || "").trim().toLowerCase()).filter(Boolean))];
  const missing = norm.filter(e => !cache.has(e));
  if (missing.length) {
    try {
      const res = await fetch("/api/square-attributes", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ emails: missing }),
      });
      if (res.ok) {
        const data = await res.json();
        missing.forEach(e => cache.set(e, Array.isArray(data[e]) ? data[e] : []));
      }
    } catch (e) { /* leave uncached; try again next time */ }
  }
  const out = {};
  norm.forEach(e => { out[e] = cache.get(e) || []; });
  return out;
}

export const membershipFor = (map, email) => (map && map[(email || "").trim().toLowerCase()]) || [];

// ─── SQUARE TIPS ──────────────────────────────────────────────────────────────
// Card-reader tips for a date range, via the /api/square-tips proxy. Returns
// { tz, tips: [{ date, tip, total, email, name, customerId, paymentId }] } where
// `date` is the local business-day so it lines up with appointment dates.
export async function fetchTips(fromISO, toISO) {
  try {
    const res = await fetch(`/api/square-tips?from=${encodeURIComponent(fromISO)}&to=${encodeURIComponent(toISO || fromISO)}`);
    if (!res.ok) return { tips: [], error: true };
    return await res.json();
  } catch (e) {
    return { tips: [], error: true };
  }
}
